/*eslint-disable*/
import React, {useState, useEffect} from "react";

import APIClient from "../client";
import config from "../config.js";

import AuthNavbar from "../components/Navbars/AuthNavbar.js";

import CardPlatformDashboard from "../components/Cards/CardPlatformDashboard.js";
import CardError from "../components/Cards/CardError.js";

import '../assets/styles/App.css';
import "@fontsource/montserrat";


const client = new APIClient(config);

export default function PlatformDashboard() {

    const [all, setAll] = useState({});
    const [platform, setPlatform] = useState({});
    const [performanceData, setPerformanceData] = useState({});

    const [chartData, setChartData] = useState({});
    const [status, setStatus] = useState();
    const [lastUpdate, setLastUpdate] = useState('2022-09-01 00:00');
    const [message, setMessage] = useState();

    const screenSize = (window.innerWidth >= 912);
    const screenSizeTwo = (window.innerWidth >= 1024);

    document.title = "Platform";

    useEffect(() => {
        Promise.all([
            client.getPlatformSummary('Platform'),
            client.getPlatformOverview('All')
        ])
            .then(([resAll, resPlatform]) =>
                Promise.all([resAll, resPlatform])
            )
            .then(([dataAll, dataPlatform]) => {
                if ([dataAll, dataPlatform]) {

                    setAll(dataAll['data']['data']);
                    setPlatform(dataPlatform['data']['data']);

                    const reportData = {...dataAll['data']['data'], ...dataPlatform['data']['data']};
                    setPerformanceData(reportData);
                    setChartData(reportData);

                    setStatus(200);
                    setMessage(String(dataAll.message));
                    setLastUpdate(reportData.date);
                } else {
                    setStatus(500);
                }
            })
            .catch(function (error) {
                setStatus(500);
                setMessage("Looks like we cant show this at the moment.");

            })
    }, []);

    return (
        <>
            <section>
                <AuthNavbar />
            </section>

            <section className="relative grad-1 pb-20">
                <div className="container relative mx-auto pt-12 px-4 w-10/12">

                    {(status === 200) ?
                        (
                            <>

                                <h2 className="text-36 text-yellow">Platform</h2>
                                <p className="text-20-30 text-white">
                                    An overview of JUMO’s market leading lending infrastructure.
                                </p>

                                <CardPlatformDashboard chartData={performanceData}/>

                                <div className="container mx-auto mt-b px-8">
                                    <p className="text-white text-16-150 text-right">Last updated {lastUpdate}</p>
                                </div>
                            </>

                        ) : <CardError message={message}/>
                    }

                </div>

            </section>
        </>
    );
}